import {FC, useEffect, useState} from 'react'
import {Navigate} from 'react-router-dom'
import {AppLoading} from '../../_metronic/helpers/components/AppLoading'
import {getWorkspaceAvailable} from '../modules/apps/partner-workspace/core/_requests'
import {useAuth} from '../modules/auth'
import {
  DEFAULT_POST_LOGIN_PATH,
  mayOpenPartnerWorkspace,
  PARTNER_WORKSPACE_PATH,
} from '../modules/auth/core/postLoginPath'

/** How long the landing waits for the answer before it opens the dashboard anyway. */
export const PARTNER_CHECK_TIMEOUT_MS = 4000

/**
 * Where a sign-in or a chosen business lands: a partner's business opens on «پیشخوان همکاری», every other on
 * its dashboard (the user, 2026-10-28: «اینهایی که همکار هستن مستقیم برن توی داشبورد همکاری»). The answer is
 * the side menu's own availability check; when it fails or is late, the dashboard opens, as before.
 */
export const BusinessLanding: FC = () => {
  const {currentUser} = useAuth()
  const ask = mayOpenPartnerWorkspace(currentUser)
  const [target, setTarget] = useState<string | undefined>(
    ask ? undefined : DEFAULT_POST_LOGIN_PATH
  )

  useEffect(() => {
    if (!ask) return
    const controller = new AbortController()
    const timer = window.setTimeout(() => controller.abort(), PARTNER_CHECK_TIMEOUT_MS)
    getWorkspaceAvailable(controller.signal)
      .then((answer) =>
        setTarget(answer.available ? PARTNER_WORKSPACE_PATH : DEFAULT_POST_LOGIN_PATH)
      )
      .catch(() => setTarget(DEFAULT_POST_LOGIN_PATH))
      .finally(() => window.clearTimeout(timer))
    return () => {
      window.clearTimeout(timer)
      controller.abort()
    }
  }, [ask])

  if (!target) return <AppLoading mode='page' message='در حال ورود…' />
  return <Navigate to={target} replace />
}
